import * as ActionTypes from "constants/ActionTypes";
import { combineReducers } from "redux";

function browserLanguages(state = [], action) {
  switch (action.type) {
    case ActionTypes.SET_BROWSER_LANGUAGES:
      return action.languages;
    default:
      return state;
  }
}

function forceDashPlayback(state = false, action) {
  switch (action.type) {
    case ActionTypes.FORCE_DASH_PLAYBACK:
      return action.force;
    case ActionTypes.FORCE_HLS_PLAYBACK:
      return false;
    default:
      return state;
  }
}

function forceHlsPlayback(state = false, action) {
  switch (action.type) {
    case ActionTypes.FORCE_HLS_PLAYBACK:
      return action.force;
    case ActionTypes.FORCE_DASH_PLAYBACK:
      return false;
    default:
      return state;
  }
}

function screenDimensions(state = { height: 0, width: 0 }, action) {
  switch (action.type) {
    case ActionTypes.SET_SCREEN_DIMENSIONS:
      return action.dimensions;
    default:
      return state;
  }
}

function rawUserAgent(
  state = typeof window === "undefined" ? "" : window.navigator.userAgent,
  action,
) {
  switch (action.type) {
    case ActionTypes.SET_USERAGENT:
      return action.userAgent;
    default:
      return state;
  }
}

export default combineReducers({
  browserLanguages,
  forceDashPlayback,
  forceHlsPlayback,
  screenDimensions,
  rawUserAgent,
});
